import { ISubDomain } from "shared/types";

let subdomain = window.location.host.split(".")[0];

if (process.env.REACT_APP_TM_ENV === "venues") {
  subdomain = ISubDomain.venues;
}

if (process.env.REACT_APP_TM_ENV === "bands") {
  subdomain = ISubDomain.bands;
}

export const isVenueDomain = subdomain === ISubDomain.venues;
export const isBandsDomain = subdomain === ISubDomain.bands;
